module.exports = __webpack_public_path__ + "img/EnracineScreenshot2_1078x576.e22e5225.png";